import type { ChangeState, GridOptions, GridRow, SaveStateParams } from '../grid.types';

export function getAutoSaveGroupKey(params: SaveStateParams): string {
    return `${params.state}:${params.rowId ?? 'all'}`;
}

export function getPostSaveDatatask<TType extends GridRow = GridRow>(options: GridOptions<TType>): number | null {
    const method = options.dataTask?.saveData?.postSaveDatatask;

    if (method === null || method === undefined || isNaN(Number(method))) return null;

    const methodNumber = Number(method);

    return methodNumber > 0 ? methodNumber : null;
}

export function getPostSaveDebounceTime<TType extends GridRow = GridRow>(options: GridOptions<TType>): number {
    const debounceTime = Number(options.dataTask?.saveData?.postSaveDebounceTime ?? 0);

    return isNaN(debounceTime) ? 0 : Math.max(0, debounceTime);
}

export function getPendingChangeRowIdsForState<TType extends GridRow = GridRow>(options: GridOptions<TType>, state: ChangeState, rowId?: string): string[] {
    return Object.entries(options.data?.changes ?? {})
        .filter(([changeRowId, change]) => change.state === state && (!rowId || changeRowId === rowId))
        .map(([changeRowId]) => changeRowId);
}
